import {
  NavIconHome,
  NavIconPlug,
  NavIconList,
  NavIconArchive,
  NavIconCloud,
  NavIconRadar,
  NavIconShield,
  NavIconCog,
} from "./NavIcons";
import type { NavItem } from "./types";

export const SIDEBAR_WIDTH = 208;
export const SIDEBAR_COLLAPSED_WIDTH = 56;
export const TOP_NAV_HEIGHT = 56;
export const COLLAPSE_SIDEBAR_BREAKPOINT = 1200;
export const COMPACT_SEARCH_BREAKPOINT = 992;
export const NAV_STATE_KEY = "navBarState";

export const NAV: NavItem[] = [
  { to: "/", label: "Overview", icon: (a) => <NavIconHome active={a} /> },
  { to: "/connectors", label: "Connectors", icon: (a) => <NavIconPlug active={a} /> },
  { to: "/sources", label: "Sources", icon: (a) => <NavIconList active={a} /> },
  { to: "/scanner", label: "Scanner", icon: (a) => <NavIconRadar active={a} /> },
  { to: "/artifacts", label: "Artifacts", icon: (a) => <NavIconArchive active={a} /> },
  { to: "/endpoints", label: "Ingest Endpoints", icon: (a) => <NavIconCloud active={a} /> },
  { to: "/audit", label: "Audit Log", adminOnly: true, icon: (a) => <NavIconShield active={a} /> },
  { to: "/settings", label: "Settings", icon: (a) => <NavIconCog active={a} /> },
];
